import { useMutation, useQueryClient } from '@tanstack/react-query';
import { serviceVendorsClient } from '@/services/petseo.service';
import type { UpdateScheduleRequest, ServiceVendorId, EmployeeId, EmployeeScheduleId } from '@/services/api/petseo.client.wrapper';
import { TOAST_MESSAGES, employeeScheduleKeys, toast } from '@petseo/shared';

interface UpdateScheduleParams {
  serviceVendorId: ServiceVendorId;
  serviceVendorEmployeeId: EmployeeId;
  scheduleId: EmployeeScheduleId;
  data: UpdateScheduleRequest;
}

export const useUpdateSchedule = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ serviceVendorId, serviceVendorEmployeeId, scheduleId, data }: UpdateScheduleParams) => {
      const response = await serviceVendorsClient.putScheduleEndpoint(
        data,
        String(serviceVendorId),
        String(serviceVendorEmployeeId),
        String(scheduleId)
      );
      return response.data;
    },
    onSuccess: (_, { serviceVendorId, serviceVendorEmployeeId }) => {
      queryClient.invalidateQueries({ queryKey: employeeScheduleKeys.forEmployee(serviceVendorId, serviceVendorEmployeeId) });
      toast.success(TOAST_MESSAGES.SCHEDULE_SAVED);
    },
    onError: () => toast.error(TOAST_MESSAGES.SCHEDULE_SAVE_ERROR),
  });
};
